import axios from 'axios';

import { COST_CENTER_PUBLICATION } from 'RestAPIs/endpoints';

export type PublicationInfo = {
  lastPublishDate: string | null;
  visibleUntilDate: string | null;
};

export const getLatest = (costCenters: number[]) =>
  axios.get<PublicationInfo>(`${COST_CENTER_PUBLICATION}/latest`, {
    params: { costCenters: costCenters.join() }
  });
